import React from 'react'
import { Outlet } from 'react-router-dom'

function MainEmailsent() {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default MainEmailsent
